import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import { LIMIT_TRANSLATE_RETRY, AIPATENT_INCLUDE, GOOGLE_PARAGRAPH_MARK_SYMBOL } from '@/constants';
import retry from '@/utils/retry';
import { transformByHtmlInnerText, TextSlicer } from '@/utils';
import { getViewParams } from 'library-@/utils/get-params';
import { translateByMachine, translateByPatsnapApi } from 'library-@/apis/core_basic_api/translate';
import { DEFAULT_LANGUAGE } from '@/services/_translation/constants';

const excludes = ['hasValidHash', 'patentId', 'highlight'];
const highlight = true;
const TRANSLATE_TYPE = 'AI';

const handleResult = (lines = [], withHTML) => {
    const result = lines.reduce((html, line) => {
        const value = line.trim();
        return value.length > 0 ? (withHTML ? html += `<p>${value}</p>` :  html += value) : html;
    }, '');
    return result;
};

export const translateByPatsnap = async ({
    patentId, lang, section, original = false
}) => {
    lang = lang === DEFAULT_LANGUAGE || !lang ? '' : lang;

    const path = `data.data.${section}.${lang}`;
    const params = getViewParams({ excludes });
    const data = {
        patent_id: patentId,
        highlight,
        lang,
        original,
        field: section,
        ...params
    }
    try {
        const result = await translateByPatsnapApi(patentId, data);
        return get(result, path);
    } catch (e) {
        return;
    }
};

export const _translateByGoogleBaidu = async ({
    text, patentId, from, to, field, withHTML = true
}) => {
    const data = {
        from, text, to, patentId, field
    };

    if (!text) {
        return handleResult([]);
    }

    if (AIPATENT_INCLUDE.includes(to)) {
        data.to = to.replace(TRANSLATE_TYPE, '');
        data.type = TRANSLATE_TYPE;
    }
    const result = await translateByMachine(data);

    const markSymbol = data.type === TRANSLATE_TYPE ? '<br/>' : GOOGLE_PARAGRAPH_MARK_SYMBOL;
    return handleResult((get(result, 'data.data.text', '')).split(markSymbol), withHTML);
};

export const translateByGoogleBaiduWithRetry = retry(_translateByGoogleBaidu, {
    times: LIMIT_TRANSLATE_RETRY,
    untilFn(data) {
        // 重试直到该函数返回为真
        if (!data) console.log('try again');
        return data;
    }
});

export const translateByGoogleBaidu = async ({
    patentId, text, from, to, field
}, callback) => {
    const content = transformByHtmlInnerText(text);
    const texts = TextSlicer()(content);
    console.info(texts.length);

    const result = [];
    const fn = async texts => {
        if (texts.length === 0) return;
        const text = texts.shift();
        const value = await translateByGoogleBaiduWithRetry({
            patentId, text, from, to, field
        }).execute();
        if (value) {
            result.push(value);
            if (isFunction(callback)) {
                const data = handleResult(result);
                callback(data);
            }
            await fn(texts);
        }
    };
    await fn(texts);
    return handleResult(result);
};
